import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }

import { ref, watch } from 'vue';
import { useMutation } from '@vue/apollo-composable';
import { UserUpdateDocument } from '@/gql/graphql';
import {
  BAlert,
  BButton,
  BForm,
  BFormGroup,
  BFormCheckbox,
  BSpinner,
  BTooltip,
} from 'bootstrap-vue-next';
import {
  NotificationItem,
  reviseNotifications,
} from '@/utils/notification-utils';

// --- Props for user details ---

export default /*@__PURE__*/_defineComponent({
  __name: 'UserNotifications',
  props: {
    notifications: {},
    loading: { type: Boolean }
  },
  emits: ['userUpdated'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

// --- Local state for user details ---
const userNotifications = ref<NotificationItem[]>([]);

// Watch the incoming user details for updates => update local form
watch(
  () => props.notifications,
  (newVal) => {
    console.debug(
      'User notifications updated: outside of the UserNotifications component',
      newVal
    );
    userNotifications.value = reviseNotifications(props.notifications);
  },
  { immediate: true }
);

// --- Emit "userUpdated" when personal details are updated ---
const emits = __emit;

// Loading and Error States
const mutationInProgress = ref(false);
const showUpdateSuccess = ref(false);
const mutationError = ref<string | null>(null);

// --- Mutation to updated user`s personal details ---
const {
  mutate: updateDetails,
  onDone: onUpdateDone,
  onError: onUpdateError,
} = useMutation(UserUpdateDocument);

// Handle the result of the mutation
onUpdateDone((res) => {
  if (res.data && res.data.userUpdate) {
    console.debug('User notifications updated:', res.data.userUpdate);
    emits('userUpdated');
    // Show success indicator and hider after 2 seconds
    mutationInProgress.value = false;
    showUpdateSuccess.value = true;
    setTimeout(() => {
      showUpdateSuccess.value = false;
    }, 1000);
  } else {
    console.error('User update failed:', res.data);
  }
});

// Handle errors in the mutation
onUpdateError((err) => {
  console.error('Error updating user notification settings:', err);
  mutationInProgress.value = false;
  mutationError.value = err.message;
});

// Submit form with personal details
async function onSubmit() {
  // Reset error and submit the update request
  mutationError.value = null;
  mutationInProgress.value = true;

  updateDetails({
    notifications: userNotifications.value,
  });
}

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(BForm), {
      onSubmit: _withModifiers(onSubmit, ["prevent"])
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userNotifications.value, (notification) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: notification.name
          }, [
            _createVNode(_unref(BFormCheckbox), {
              modelValue: notification.enabled,
              "onUpdate:modelValue": ($event: any) => ((notification.enabled) = $event)
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(notification.label) + " ", 1),
                _createVNode(_component_font_awesome_icon, {
                  id: notification.name,
                  icon: "question-circle",
                  class: "me-2 text-secondary"
                }, null, 8, ["id"])
              ]),
              _: 2
            }, 1032, ["modelValue", "onUpdate:modelValue"]),
            _createVNode(_unref(BTooltip), {
              target: notification.name,
              title: notification.description
            }, null, 8, ["target", "title"])
          ], 64))
        }), 128)),
        _createVNode(_unref(BFormGroup), { class: "mt-3" }, {
          default: _withCtx(() => [
            _createVNode(_unref(BButton), {
              type: "submit",
              variant: "outline-dark",
              disabled: mutationInProgress.value
            }, {
              default: _withCtx(() => [
                (mutationInProgress.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
                      _cache[2] || (_cache[2] = _createTextVNode(" Saving Changes ", -1)),
                      _createVNode(_unref(BSpinner), {
                        small: "",
                        label: ""
                      })
                    ]))
                  : (showUpdateSuccess.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                        _cache[3] || (_cache[3] = _createTextVNode(" Changes Saved ", -1)),
                        _createVNode(_component_font_awesome_icon, {
                          icon: ['fa', 'check-double'],
                          class: "me-2"
                        })
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_3, " Save Changes "))
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _: 1
        }),
        _createVNode(_unref(BAlert), {
          modelValue: mutationError.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((mutationError).value = $event)),
          variant: "danger",
          dismissible: "",
          class: "mt-3",
          onDismissed: _cache[1] || (_cache[1] = ($event: any) => (mutationError.value = null))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(mutationError.value), 1)
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    })
  ]))
}
}

})